import { EDGE_TYPE } from "~/constants";
import type { ObjectReference } from "./dataObject";
import type { Edge } from "./edge";

export enum EdgeStatus {
  GOOD = "GOOD",
  BAD = "BAD",
  PARTIALLY_GOOD = "PARTIALLY_GOOD",
}

export const isAiRanEdge = (edge?: { services?: { name: string }[] | null } | null): edge is AIRan =>
  edge?.services?.some((service) => service.name === EDGE_TYPE.AI_RAN) ?? false;

export interface AIRan extends Edge {
  services: [{ name: "AI_RAN" }];
  aiRan: {
    radioGroup: ObjectReference;
    radioSite: ObjectReference;
    serialNumber: string;
    technology?: string;
    gNBId: number;
    gNBIdLength?: number;
  };
  connectedEdges: ObjectReference[];
  runtimeInfo: Edge["runtimeInfo"] & {
    aiRan: {
      o1Reachable: boolean;
      ngConnected: boolean;
      alarmCount: number;
      softwareVersion: string;
      ipAddress: string;
    };
    edgeStatus: {
      overallEdgeStatus: EdgeStatus;
      perEdgeStatus: {
        edgeId: string;
        status: EdgeStatus;
      }[];
    };
  };
}